import React from 'react';
import { getMessage } from '@tcc/i18n';
import { UpgradeModal } from '@tcc/product-packaging-web';
import { ModalMode } from '../../../types';

export type PaywallModalProps = {
  show: boolean;
  onClose: () => void;
  modalMode: ModalMode;
}

function getMessageKeys(modalMode: ModalMode) {
  switch (modalMode) {
    case ModalMode.PAYWALL_SCOUTING:
      return {
        titleKey: 'productPackaging.scouting.title',
        descriptionKey: 'productPackaging.scouting.description',
        itemsKeys: [
          'productPackaging.scouting.item1',
          'productPackaging.scouting.item2',
          'productPackaging.scouting.item3'
        ]
      };
    case ModalMode.PAYWALL_IMAGERY:
      return {
        titleKey: 'productPackaging.fha.title',
        descriptionKey: 'productPackaging.fha.description',
        itemsKeys: [
          'productPackaging.scouting.item1',
          'productPackaging.scouting.item2',
          'productPackaging.scouting.item3'
        ]
      };
    case ModalMode.PAYWALL_FIELD_NOTES:
      return {
        titleKey: 'productPackaging.scouting.title',
        descriptionKey: 'productPackaging.fieldNotes.description',
        itemsKeys: [
          'productPackaging.scouting.item1',
          'productPackaging.scouting.item2',
          'productPackaging.scouting.item3'
        ]
      };
    case ModalMode.PAYWALL_REGION_REPORT:
      return {
        titleKey: 'productPackaging.regionReport.title',
        descriptionKey: 'productPackaging.regionReport.description',
        itemsKeys: [
          'productPackaging.regionReport.item1',
          'productPackaging.regionReport.item2',
          'productPackaging.regionReport.item3'
        ]
      };
    case ModalMode.PAYWALL_FIELD_HEALTH:
      return {
        titleKey: 'productPackaging.fha.title',
        descriptionKey: 'productPackaging.fha.description',
        itemsKeys: [
          'productPackaging.scouting.item1',
          'productPackaging.scouting.item2',
          'productPackaging.scouting.item3'
        ]
      };
    case ModalMode.PAYWALL_SPLIT_VIEW:
      return {
        titleKey: 'productPackaging.scouting.title',
        descriptionKey: 'productPackaging.splitView.description',
        itemsKeys: [
          'productPackaging.splitView.item1',
          'productPackaging.splitView.item2',
          'productPackaging.splitView.item3'
        ]
      };

    default:
      return {
        titleKey: 'productPackaging.fha.title',
        itemsKeys: [
          'productPackaging.scouting.item1',
          'productPackaging.scouting.item2',
          'productPackaging.scouting.item3'
        ]
      };
  }
}

export function PaywallModal({ show, onClose, modalMode }: PaywallModalProps) {
  const { titleKey, descriptionKey, itemsKeys } = getMessageKeys(modalMode)

  return (
    <UpgradeModal
      show={show}
      title={getMessage(titleKey)}
      description={getMessage(descriptionKey)}
      items={itemsKeys.map(item => getMessage(item))}
      onClose={onClose}
    />
  )
}
